module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA4CAYAAABqtn+aAAAABGdBTUEAALGPC/xhBQAAALNJREFUeAHt2bENgDAQA0DCRMzAAMzE6Ej0L1m45FK+3s3FVbKu87g357PA/jkp+AoALIsAEGApUMY1EGApUMY1sAQUJ0CAAAECBAgQIECAAAECBAgQIEDgPwLLv3B32V6kO78NIMBSoIxrIMBSoIxrIMBSQJwAAQIECBAgQIAAAQIECBAgQIAAAQKhgH/hEGpa86Q/yYRzgCHUtAZwkgnnAEOoaQ3gJBPOAYZQ0xrASSacP/guA+4HGbLYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/burger.png
// module id = 1041
// module chunks = 168707334958949